function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* istanbul ignore file */

import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import CaretLeftIcon from "@digital-hig/icon/lib/esm/icons/caret-left";
import CaretRightIcon from "@digital-hig/icon/lib/esm/icons/caret-right";
export var makePaginationStyles = function makePaginationStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiPagination: {
      defaultProps: {
        shape: "rounded",
        variant: "outlined"
      },
      styleOverrides: {
        root: {
          '& + [class*="MuiTypography-root"]': {
            lineHeight: primitives.lineHeights["compact"],
            paddingTop: primitives.spacings["1"]
          },
          '&[single="true"]': {
            "& .Mui-selected, & .Mui-selected.Mui-disabled": {
              backgroundColor: "transparent",
              border: 0,
              color: tokens.colors["ink-on-background"],
              opacity: tokens.opacities.default
            }
          }
        },
        ul: {
          justifyContent: "center",
          "& li": {
            margin: "0px 2px",
            "&:focus-visible": {
              outline: "none"
            }
          }
        }
      }
    },
    MuiPaginationItem: {
      defaultProps: {
        shape: "rounded",
        slots: {
          // eslint-disable-next-line react/display-name
          previous: function previous() {
            return /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CaretLeftIcon, null));
          },
          // eslint-disable-next-line react/display-name
          next: function next() {
            return /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CaretRightIcon, null));
          }
        },
        variant: "outlined"
      },
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({
          border: "".concat(primitives.borderWidths["medium"], " solid transparent"),
          padding: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["3"])
        }, tokens.typography["short-copy-small"]), {}, {
          lineHeight: primitives.lineHeights["default"],
          minWidth: primitives.spacings["7"],
          maxWidth: primitives.spacings["7"],
          height: primitives.spacings["7"],
          margin: 0,
          borderRadius: primitives.borderRadii.round
        }, tokens.transitions["state-blur"]), {}, {
          color: tokens.colors["ink-on-background"],
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["activated-fill-subtle"]
          }, tokens.transitions["state-activate"]),
          "&:active": _objectSpread({
            backgroundColor: tokens.colors["activated-hover-fill-subtle"]
          }, tokens.transitions["state-activate"]),
          "&:focus-visible": _objectSpread({
            backgroundColor: tokens.colors["ink-on-fill-primary"],
            boxShadow: tokens.effects["focus-ring-reverse"]
          }, tokens.transitions["state-activate"]),
          "&.Mui-selected": _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["ink-on-fill-primary"],
            border: "".concat(primitives.borderWidths["medium"], " solid ").concat(tokens.colors["ink-on-background"])
          }, tokens.transitions["state-activate"]), {}, {
            "&:hover": {
              backgroundColor: tokens.colors["ink-on-fill-primary"]
            },
            "&:focus-visible": {
              backgroundColor: tokens.colors["ink-on-fill-primary"]
            }
          }),
          "&.Mui-disabled": {
            border: 0
          }
        }),
        previousNext: {
          borderRadius: "50%",
          minWidth: primitives.spacings["6"],
          maxWidth: primitives.spacings["6"],
          height: primitives.spacings["6"],
          padding: "unset"
        },
        ellipsis: {
          cursor: "default",
          "&:hover, &:active, &:focus-visible": {
            backgroundColor: "transparent"
          }
        },
        rounded: {
          borderRadius: primitives.borderRadii.small
        }
      }
    }
  };
};